module.exports = __webpack_public_path__ + "static/media/PH.d99ad691.svg";